import { makeAutoObservable } from 'mobx'

import { themeStore, type ThemeMode } from '@/Ship/Stores/ThemeStore'

/** Окремий ключ: вибір водія не має впливати на тему адмінки в тому ж браузері */
const STORAGE_KEY = 'autostrada.driver.theme'

const read = (): ThemeMode => {
    try {
        return window.localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark'
    } catch {
        return 'dark'
    }
}

/**
 * Тема кабінету водія. Темна за замовчуванням (кабіна вночі), світла — для сонця.
 * Поки відкритий кабінет, вибір примусово ставиться в ThemeStore (forceMode), щоб
 * CSS-змінні PWA й antd перемкнулись разом; при виході з кабінету ThemeStore
 * повертає збережений вибір адмінки.
 */
export class DriverThemeStore {
    mode: ThemeMode = read()

    constructor() {
        makeAutoObservable(this)
    }

    setMode(mode: ThemeMode): void {
        this.mode = mode
        try {
            window.localStorage.setItem(STORAGE_KEY, mode)
        } catch {
            // приватний режим: тема живе до перезавантаження
        }
        themeStore.forceMode(mode)
    }

    toggle(): void {
        this.setMode(this.mode === 'dark' ? 'light' : 'dark')
    }

    /** Застосувати при вході в кабінет водія */
    apply(): void {
        themeStore.forceMode(this.mode)
    }
}

export const driverThemeStore = new DriverThemeStore()
